// Figma: https://www.figma.com/design/iYlbYhvyJjh7X00UAcqCWt/About-page?node-id=13-46
import { Box, Image } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { HeroSection } from "./components/HeroSection";
import { CEOSection } from "./components/CEOSection";
import { WhatWereBuildingSection } from "./components/WhatWereBuildingSection";
import { ManifestoSection } from "./components/ManifestoSection";
import { SignupSection } from "./components/SignupSection";
import { GetInTouchSection } from "./components/GetInTouchSection";
import { FooterSection } from "./components/FooterSection";
import { aboutAsset } from "./aboutAssets";

const comicGridHeader = aboutAsset("comic-grid-header.png");
const comicGridFooter = aboutAsset("comic-grid-footer.png");

const PARALLAX_SPEED = 0.35; // 0 = fixed, 1 = scrolls normally

export function AboutScreen() {
  const headerGridRef = useRef<HTMLDivElement>(null);
  const footerGridRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let rafId = 0;
    const onScroll = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const y = window.scrollY * PARALLAX_SPEED;
        if (headerGridRef.current) {
          headerGridRef.current.style.transform = `translate3d(0, ${y}px, 0)`;
        }
        if (footerGridRef.current) {
          footerGridRef.current.style.transform = `translate3d(0, ${y}px, 0)`;
        }
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <Box bg="charcoal.charcoal" position="relative" w="100%">
      {/* Header background comic grid at 10% opacity (13:47) — extends from top through CEO section */}
      <Box
        ref={headerGridRef}
        position="absolute"
        top="0"
        left="0"
        w="100%"
        h="1200px"
        zIndex={0}
        pointerEvents="none"
        overflow="hidden"
        willChange="transform"
      >
        <Image
          src={comicGridHeader}
          alt=""
          w="100%"
          h="100%"
          objectFit="cover"
          objectPosition="center top"
        />
        {/* Gradient fade at bottom edge */}
        <Box
          position="absolute"
          inset="0"
          bgGradient="linear(to-b, transparent 50%, charcoal.charcoal)"
        />
      </Box>

      {/* Content sections */}
      <Box position="relative" zIndex={1}>
        <HeroSection />
        <CEOSection />

        {/* Footer background comic grid (13:5509) — behind building + manifesto + contact */}
        <Box position="relative">
          <Box
            ref={footerGridRef}
            position="absolute"
            top="560px"
            left="0"
            w="100%"
            pointerEvents="none"
            willChange="transform"
          >
            <Image
              src={comicGridFooter}
              alt=""
              w="100%"
              display="block"
            />
          </Box>

          <Box position="relative" zIndex={1}>
            <WhatWereBuildingSection />
            <ManifestoSection />
            <SignupSection />
            <GetInTouchSection />
            <FooterSection />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
